import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import DatePicker from "./datepicker"
import DatePickerCompare from "./datepickerCompare"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import { saveAs } from "file-saver"
import moment from "moment"
import _ from "lodash"
import classNames from "classnames"
import { compareStatus, updateCompareDates, loadingStatus } from "actions"
import settings from "settings"
import classnames from "classnames"

class Title extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sidebarOpen: true,
			processing: false,
		}
	}

	async pdf() {
		this.props.loadingStatus(true)
		let properties = ""
		if (this.props.activeProperties.length > 0) {
			let props = []
			_.forEach(this.props.activeProperties, (v) => {
				let p = _.find(this.props.payload.public.properties, { id: parseInt(v) })
				if (p) props.push(p.name)
			})
			if (props.length > 0) {
				properties = props.join(", ")
				properties = _.trim(properties, ", ")
			}
		}
		if (properties) properties = `${properties} | `
		let text = `${this.props.title} | ${properties}Date of Report: ${moment().format(
			"MM/DD/YYYY"
		)} | Selected Date Range: ${this.props.currentDates.startText} - ${this.props.currentDates.endText}`
		let make = async () => {
			const computedStyleToInlineStyle = require("computed-style-to-inline-style")
			let eles = document.getElementsByClassName("imageGroup")
			let arr = []
			//? Adjustments is when the PDF isn't laying out like the browser.  This allows you to add a "pdf" class to any element and it will be adjusted for the PDF.  Just add to the array below, then adjust the CSS in global.scss.
			let adjustedElements = ["quickStats__stat", "quickStats__type", "quickStats__whiteBox", "weekly__optionBox"]
			let adjustments = document.querySelectorAll(adjustedElements.map((v) => `.${v}`).join(","))
			_.forEach(adjustments, (v) => {
				v.classList.add("pdf")
			})
			for (let v of eles) {
				// Added computed due to gauges not keeping properties on <text> elements
				//v.style.paddingTop = "90px"
				computedStyleToInlineStyle(v, {
					recursive: true,
					properties: ["font-family", "text-anchor"],
				})

				arr.push(
					await html2canvas(v, {
						useCORS: true,
					})
				)
			}
			if (arr.length > 0) {
				var doc = new jsPDF("p", "mm")

				// Add a header for the first page
				doc.setFontSize(12)
				doc.setTextColor(0, 0, 0)
				doc.setFontSize(7) // Smaller font size
				//doc.setFont("helvetica")
				doc.text(text, 5, 5, {
					align: "left",
				})

				var imgWidth = 200

				_.forEach(arr, (v, k) => {
					let imgData = v.toDataURL("image/jpeg")
					var imgHeight = (v.height * imgWidth) / v.width
					var heightLeft = imgHeight
					var pageHeight = 295

					while (heightLeft >= 0 && imgHeight > 0) {
						var position = heightLeft - imgHeight + 10
						doc.addImage(imgData, "JPEG", 5, position, imgWidth, imgHeight)
						doc.addPage()

						// Add the header to subsequent pages
						doc.text(text, 5, 5, {
							align: "left",
						})

						heightLeft -= pageHeight
					}
				})

				// Delete last blank page
				var pageCount = doc.internal.getNumberOfPages()
				doc.deletePage(pageCount)
				// Save file..
				doc.save("pipsy-report.pdf")
				_.forEach(adjustments, (v) => {
					v.classList.remove("pdf")
				})
			}
			for (let v of eles) {
				v.style.paddingTop = "0px"
			}
			this.setState({ processing: false })
			this.props.loadingStatus(false)
		}
		this.setState({ processing: true }, () => {
			make()
		})
	}

	jpg() {
		this.props.loadingStatus(true)
		const input = document.getElementById("stage")
		let make = () => {
			html2canvas(input, { useCORS: true, scale: 3 }).then((canvas) => {
				const imgData = canvas.toDataURL("image/jpeg")
				var imgWidth = 210
				var pageHeight = 295
				var imgHeight = (canvas.height * imgWidth) / canvas.width
				var heightLeft = imgHeight
				//console.log(canvas.toDataURL())
				saveAs(canvas.toDataURL(), "pipsy-report.jpg")
				this.setState({ processing: false })
				this.props.loadingStatus(false)
			})
		}
		this.setState({ processing: true }, () => {
			make()
		})
	}

	compare = () => {
		var status = !this.props.currentCompareStatus
		if (!status) {
			this.props.updateCompareDates(false)
			localStorage.removeItem("compareDates")
		} else {
			this.props.updateCompareDates(true)
		}
		this.props.compareStatus(status)
	}

	showCompare = () => {
		if (this.props.compare) {
			let compareText = this.props.currentCompareStatus ? "Remove Comparison" : "Compare Dates"
			return (
				<>
					{this.props.currentCompareStatus ? <DatePickerCompare /> : null}
					<div className="title__compareToggle" onClick={this.compare}>
						{compareText}
					</div>
				</>
			)
		}
	}

	render() {
		let activeProps = ""
		if (this.props.showDate !== false) {
			var dates = (
				<div className="title__date">
					<DatePicker years={this.props.years} custom={this.props.custom} quarters={this.props.quarters} />
					{this.showCompare()}
				</div>
			)
		}
		if (this.props.echoActive) {
			let ap = ""
			ap = _.map(this.props.activeProperties, (v) => {
				let prop = _.find(this.props.payload.public.properties, { id: v })
				return prop.name
			})
			ap = ap.join(", ")
			activeProps = <h3>{ap}</h3>
		}
		let logo = false
		if (this.props.activeProperties.length == 1) {
			let prop = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
			if (prop && prop.logo) logo = prop.logo
		}
		return (
			<>
				{logo && (
					<div className={classnames("content", "logoExport", { active: this.state.processing })}>
						<img crossOrigin="anonymous" src={`${settings.s3}/${logo}`} />
					</div>
				)}

				<div className="title">
					{this.props.hideExport ? null : (
						<div className="title__exportCont" data-html2canvas-ignore="true">
							<p className="title__export">Entire Page Export:</p>
							<p className="title__export" onClick={() => this.pdf()}>
								<i className="fas fa-file-pdf" /> Generate PDF
							</p>
							<p className="title__export" onClick={() => this.jpg()}>
								<i className="fal fa-file-image" /> Generate JPG
							</p>
						</div>
					)}
					<div className={classNames("title__title", { title__cutPadding: this.props.cutPadding })}>
						<h1 className="flex items-center">
							{this.props.title}
							{this.props.beta ? <span className="bug ml-1">BETA</span> : ""}
							{this.props.alpha ? (
								<span
									className="bug ml-1 !bg-red-500 cursor-help"
									title="Pre-release version that is still in active development.  For preview only.">
									ALPHA
								</span>
							) : (
								""
							)}
						</h1>
						{activeProps}
					</div>
					{dates}
				</div>
			</>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeProperties: state.activeProperties,
		payload: state.payload,
		currentCompareStatus: state.compareStatus,
		currentDates: state.currentDates,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			updateCompareDates,
			compareStatus,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Title)
